import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { IRedeem, IRedeemResponse } from '../../features/redeem/redeem';

export interface IResponse<T> {
  statusCode: number;
  statusMessage: string;
  result: boolean;
  data: T;
}

export interface ICheckQuota {
  isFull: boolean;
  reason: string;
  remainingToday: number;
}

@Injectable({
  providedIn: 'root',
})
export class RedeemApi {
  private apiUrl = environment.apiUrl; // Replace with your actual API URL
  private readonly http = inject(HttpClient);

  constructor() {}

  getListMerchant() {
    return this.http
      .get<IResponse<any>>(`${this.apiUrl}public/list/merchant`)
      .pipe(catchError(this.handleError));
  }

  checkQuota(merchantName: string = 'ASIATIQUE') {
    const params = new HttpParams().set('merchantName', merchantName);
    return this.http
      .get<IResponse<ICheckQuota>>(`${this.apiUrl}public/check/quota`, { params })
      .pipe(catchError(this.handleError));
  }

  redeem(data: IRedeem) {
    return this.http
      .post<IResponse<IRedeemResponse>>(`${this.apiUrl}public/register/code`, data)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.message);
    } else {
      console.error('service::error ', error.error);
    }

    if (error.error.statusCode === 500 && error.error.statusMessage === 'Internal Server Error!') {
      error.error.statusMessage = 'Something went wrong, please try again later';
    }

    return throwError(() => error.error);
  }
}
